<template>
  <v-container fluid>
    <v-row>
      <v-col
        class="text-center"
        cols="12"
      >
        <h1
          :class="headerTitleClass"
          class="synthesis-brand-lightest-blue--text mb-8"
        >
          Press
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card
          class="synthesis-ui-blue-07 pa-4 pa-md-8 pa-lg-8 synthesis-section-border-radius"
          color="transparent"
          flat
        >
          <v-container
            class="synthesis-brand-dark-blue--text text-left"
            fluid
          >
            <v-row>
              <v-col
                cols="12"
                lg="6"
                md="8"
                offset-lg="1"
                offset-xl="1"
                xl="7"
              >
                <!-- First Article - Full Width -->
                <v-card
                  v-if="PressArticles && PressArticles.length > 0"
                  :to="{name: 'PressArticle', params: {slug: PressArticles[0].slug}}"
                  class="mb-8 mb-md-16"
                  flat
                >
                  <v-img
                    v-if="PressArticles[0].featured_media && getArticleImage(PressArticles[0], 'full')"
                    :src="getArticleImage(PressArticles[0], 'full').source_url"
                    max-height="500"
                  />

                  <v-card-text>
                    <v-chip
                      class="ma-4 float-right mt-6"
                      label
                      small
                    >
                      {{ getArticleDate(PressArticles[0]) }}
                    </v-chip>

                    <div
                      :class="sectionTitleClass"
                      class="py-4 synthesis-brand-dark-blue--text text-left font-weight-regular"
                      v-html="sanitizeText(PressArticles[0].title.rendered)"
                    />

                    <div
                      :class="sectionSubTitleClass"
                      class="synthesis-brand-dark-blue--text text-left font-weight-regular"
                      v-html="sanitizeText(PressArticles[0].content.rendered)"
                    />
                  </v-card-text>
                </v-card>

                <!-- Remaining Articles - Two per Row -->
                <v-row>
                  <v-col
                    v-for="(article, articleIdx) in PressArticles.slice(1, 3)"
                    :key="`article-${articleIdx}`"
                    class="d-flex"
                    cols="12"
                    md="6"
                  >
                    <v-card
                      :to="{name: 'PressArticle', params: {slug: article.slug}}"
                      class="mb-8 d-flex flex-column"
                      flat
                      height="100%"
                    >
                      <v-img
                        v-if="article.featured_media && getArticleImage(article, 'full')"
                        :src="getArticleImage(article, 'full').source_url"
                        height="300"
                        cover
                      />

                      <v-card-text class="d-flex flex-column flex-grow-1">
                        <div class="d-flex justify-end mb-2">
                          <v-chip
                            label
                            x-small
                          >
                            {{ getArticleDate(article) }}
                          </v-chip>
                        </div>

                        <div
                          :class="sectionSubTitleClass"
                          class="py-2 synthesis-brand-dark-blue--text text-left font-weight-regular"
                          v-html="sanitizeText(article.title.rendered)"
                        />

                        <div
                          class="synthesis-brand-dark-blue--text text-left font-weight-regular"
                          style="font-size: 14px; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                          v-html="sanitizeText(article.content.rendered)"
                        />
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <v-col
                v-if="$vuetify.breakpoint.mdAndUp"
                lg="4"
                md="4"
                xl="3"
              >
                <recent-articles articles-count="10" />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import i18nRouteMeta     from '@/mixins/i18n/i18nRouteMeta'
import CssClassFontSizes from '@/mixins/cssClassFontSizes'
import PressCommon       from '@/mixins/pressCommon'
import RecentArticles    from '@/theme/default/views/press/RecentArticles.vue'

export default {
  name      : 'Press',
  components: { RecentArticles },
  directives: {},
  mixins    : [i18nRouteMeta, CssClassFontSizes, PressCommon],
  props     : {},
  dataStore : {
    PressArticles: 'Press.Articles'
  },
  enums: {},
  data () {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods : {}
}
</script>

<style scoped>

</style>
